import type { ApplicationScopeSource } from './domain-scope';

export function resolveApplicationStartUrl({
  applicationUrl,
}: ApplicationScopeSource): string | undefined {
  const trimmed = applicationUrl?.trim();
  if (!trimmed) {
    return undefined;
  }

  const normalizedApplicationUrl = trimmed.startsWith('http')
    ? trimmed
    : `https://${trimmed}`;

  try {
    new URL(normalizedApplicationUrl);
  } catch {
    return undefined;
  }

  return normalizedApplicationUrl;
}
